<script>
    export let favicon;
    export let title;
    document.querySelector('#favicon').href = favicon;
    document.querySelector('title').textContent = title;
</script>